export default __webpack_public_path__ + "static/media/BecaMilano_Curso01_Banner_Mobile.bc445f23.jpg";